// src/services/api.js
import axios from 'axios';

// Detectar si estamos en modo mock (variable de entorno o query param)
const USE_MOCK = process.env.VUE_APP_USE_MOCK === 'true' || 
                 new URLSearchParams(window.location.search).get('mock') === 'true';

let apiClient;

if (USE_MOCK) {
  // 🔸 Modo mock: usar servicio simulado
  console.log('🧪 [API] Usando datos MOCK para desarrollo');
  
  // Crear un cliente "falso" que intercepta las peticiones
  apiClient = {

    get: async (url) => {
      const { mockApiService } = await import('./mockApi');
      
      // Extraer encodedParam de la URL: /pasajero/YXBwLTE0MTQ3 → YXBwLTE0MTQ3
      const match = url.match(/\/pasajero\/([^/]+)/);
      const encodedParam = match ? match[1] : '';
      
      const data = await mockApiService.getPasajeroEncoded(encodedParam);
      return { data }; // Axios-style response
    },
    interceptors: {
      request: { use: () => {}, eject: () => {} },
      response: { use: () => {}, eject: () => {} }
    }
  };
} else {
  console.log('🧪 [API] Usando datos para production');
  // 🔸 Modo real: axios normal
  apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || 'https://tourpass.toursolutions.cl/api',
    timeout: 15000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-api-key': process.env.VUE_APP_API_KEY
    }
  });

  // Interceptor para logs y manejo de errores (solo en modo real)
  apiClient.interceptors.response.use(
    response => response.data,
    error => {
      console.error(`❌ [API ${error.response?.status}] ${error.config?.url}:`, 
        error.response?.data?.error || error.message);
      return Promise.reject({
        status: error.response?.status,
        message: error.response?.data?.error || error.message,
        originalError: error
      });
    }
  );
}

export const apiService = {
  async getPasajeroEncoded(encodedParam) {
    const response = await apiClient.get(`/pasajero/${encodeURIComponent(encodedParam)}`);
    return response;
  },

  async getRecogidaEncoded(encodedParam) {
    return apiClient.get(`/recogida/${encodeURIComponent(encodedParam)}`);
  },

  async getLoginAgencia(codigoAgencia, fechaDesde, fechaHasta) {
    const payload = {
      codigo_agencia: codigoAgencia,
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta
    };
    
    console.log('📡 [API] Consultando login de agencia:', payload);
    const response = await apiClient.post('/login-agencia', payload);
    return response;
  },

  async getDatosAgencia(codigoAgencia, fechaDesde, fechaHasta) {
    const payload = {
      codigo_agencia: codigoAgencia,
      fecha_desde: fechaDesde,
      fecha_hasta: fechaHasta
    };
    
    console.log('📡 [API] Consultando datos de agencia:', payload);
    const response = await apiClient.post('/datos-agencia', payload);
    return response;
  },
  
  async healthCheck() {
    const response = await apiClient.get('/health');
    return response.data;
  }
};

export default apiService;